import IMask from 'imask';

const maskPhoneOptions = {
    mask: '+{7} (000) 000-00-00'
};

export default function inputMask() {
    // const element = document.getElementById('selector');
    const phoneElements = document.querySelectorAll('.js-phone-mask');
    phoneElements.forEach((el) => {
        IMask(el, maskPhoneOptions);
    });
}
